var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',[_c('div',[_vm._v("Copyright © "+_vm._s(_vm.currentYear)+" Guerrilla Dimension")]),_vm._v(" "),_c('div',[_vm._v("\"Guerrilla Dimension meets all of my DDoS needs and more.\" ~Jane Goodall")])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ff831a5a","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Footer.vue
// module id = null
// module chunks = 